import mapValuesForSubmit from './mapValuesForSubmit';
import CompanyService from 'App/services/CompanyService';

function enableUser(values) {
    const user = mapValuesForSubmit(values);

    return CompanyService.enableCompanyUser(values.id, user);
}

export default enableUser;
